import { signOutSuccess } from "store/slices/authSlice";
import i18n from "i18next";
import { AUTH_TOKEN } from "constants/AuthConstant";
import { API_BASE_URL } from "constants/ApiConstant";
import axios from "axios";
import { notification } from "antd";

import store from "../store";

const translate = (key) => {
  return i18n.t(key);
};

const unauthorizedCode = [401, 403, 500],
  unauthorizedmessage = [
    "Unauthorized",
    "Token expired",
    "Access to admin resources denied.",
  ];

const service = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  //timeout: 60000
});

// Config
const TOKEN_PAYLOAD_KEY = "Authorization";

// API Request interceptor
service.interceptors.request.use(
  (config) => {
    const jwtToken = localStorage.getItem(AUTH_TOKEN) || null;
    console.log("JWT TOKEN", jwtToken);
    if (jwtToken) {
      config.headers[TOKEN_PAYLOAD_KEY] = `Bearer ${jwtToken}`;
    }

    return config;
  },
  (error) => {
    // Do something with request error here
    notification.error({
      message: "Error",
    });
    Promise.reject(error);
  }
);

// API respone interceptor
service.interceptors.response.use(
  (response) => {
    const newAccessToken = response.headers['authorization'] || response.headers['Authorization'];
    if (newAccessToken && newAccessToken.startsWith('Bearer ')) {
      const token = newAccessToken.split(' ')[1];
      localStorage.setItem(AUTH_TOKEN, token);
      console.log("Token Refreshed in LocalStorage");
    }
    if (response.status === 201) {
      const { locale } = store.getState().theme;

      if (locale === "fr") {
        notification.success({
          description: translate(response.data.messageCode) || "success!",
          duration: 3,
        });
      } else if (locale === "en") {
        notification.success({
          description: translate(response.data.message) || "success!",
          duration: 3,
        });
      }
    }
    return response.data;
  },
  (error) => {
    const { locale } = store.getState().theme;
    let notificationParam = {
      //message: "",
      description: "",
      duration: 4,
    };

    if (
      unauthorizedCode.includes(error.response.status) &&
      unauthorizedmessage.includes(error.response?.data?.msg)
    ) {
      notificationParam.description = "Please login again";
      localStorage.removeItem(AUTH_TOKEN);
      store.dispatch(signOutSuccess());
    } else {
      if (locale === "fr") {
        notificationParam.description = translate(
          //error.response?.data.errorCode
          error.response?.data?.error
        );
      } else if (locale === "en") {
        notificationParam.description = translate(error.response?.data?.error);
      }
      //notificationParam.message = "Error"
    }

    // Remove token and redirect

    // if (error.response.status === 404) {
    //   notificationParam.message = "Not Found"
    // }

    // if (error.response.status === 500) {
    //   notificationParam.message = "Internal Server Error"
    // }

    // if (error.response.status === 508) {
    //   notificationParam.message = "Time Out"
    // }

    if (notificationParam.description) {
      notification.error(notificationParam);
    }

    return Promise.reject(error);
  }
);

export default service;
